import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  gap: 8px;
`

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0px;
`

export const FormItemWrapper = styled.div`
  width: 50%;
  ${({ right }) => right
    ? 'padding-left: 20px;  border-left: 1px solid rgba(0,0,0,.1);'
    : 'padding-right: 20px;'}

  .label-width-100 {
    label {
      width: 100%;
      &:after { display: none; }
    }
  }
`
